export default {"src":"/_next/static/media/invoice.3e699f7d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};